
import { useState, useEffect } from "react";
import { HiringStage } from "@/lib/types";
import { hiringStages as initialHiringStages } from "@/components/hiring/data";

export function useHiringStages() {
  const [currentStage, setCurrentStage] = useState(0);
  const [progress, setProgress] = useState(0);
  const [hiringStages, setHiringStages] = useState<HiringStage[]>(initialHiringStages);

  useEffect(() => {
    setProgress(((currentStage) / (hiringStages.length - 1)) * 100);
  }, [currentStage, hiringStages.length]);

  const markStageComplete = (stageIndex: number) => {
    const updatedStages = [...hiringStages];
    updatedStages[stageIndex].isCompleted = true;
    setHiringStages(updatedStages);
  };

  return {
    currentStage,
    setCurrentStage,
    progress,
    hiringStages,
    setHiringStages,
    markStageComplete,
  };
}
